export default "__VITE_ASSET__C8ydsfc___"